export interface LeadsListMapperI {
  select: boolean;
  id: string;
  title: boolean;
  status: string;
  contactName: string;
  birthdate: string;
  accountName: string;
  corporateIdentityName: string;
  createdByName: string;
  dateCreated: string;
  dateModified: string;
  description: string;
  email: string;
  firstName: string;
  lastName: string;
  salesRep: string;
  website: string;
  name: string;
  productionManagerName: string;
  salesManagerName: string;
  rating: string;
  referedBy: string;
  phoneWork: string;
  leadSource: string;
  productsOfInterest: string;
}
